import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Link from 'root/src/client/web/base/Link';
import { BaseTooltip, BaseTooltipContent } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import { PlatformIcon } from 'root/src/client/web/base/CustomButton/PlatformIcon';
import { getReadablePlatform } from 'root/src/shared/platforms/helpers/getReadablePlatform';
const RelatedProfileCard = ({ profile }) => {
    var _a;
    const formattedFollowers = new Intl.NumberFormat('en-US').format(profile.followerCount || 0);
    const platformLabel = (_a = getReadablePlatform(profile.platform)) !== null && _a !== void 0 ? _a : profile.platform;
    return (<Link href={profile.daredropUrl} className="flex items-center gap-3 border-white border p-3 hover:bg-white/5 transition-colors">
			<img className="rounded-full w-10 h-10" src={profile.image} alt={profile.displayName}/>
			<div className="flex flex-col gap-0.5 min-w-0">
				<div className="flex items-center gap-2">
					<PlatformIcon platform={profile.platform} className="text-sm"/>
					<span className="text-sm font-bold truncate">{profile.displayName}</span>
				</div>
				<span className="text-xs text-light-4">
					{platformLabel} · {formattedFollowers} followers
				</span>
			</div>
		</Link>);
};
export const RelatedProfiles = ({ profiles }) => {
    if (!profiles || profiles.length === 0)
        return null;
    return (<div className="flex flex-col gap-2">
			<div className="flex items-center gap-1.5">
				<span className="text-sm uppercase text-light-4 font-bold tracking-wider">
					Related Profiles
				</span>
				<BaseTooltip tooltip={(<BaseTooltipContent className="whitespace-pre-line max-w-xs text-left">
							{'This username exists on multiple platforms as separate, unlinked accounts.\n\nEach one has its own profile, stats, and history on Dare Drop.\n\nIf you own both, go to Connected Channels to link them into a single profile.'}
						</BaseTooltipContent>)}>
					<InfoOutlinedIcon className="text-light-4 cursor-help" style={{ fontSize: '1rem' }}/>
				</BaseTooltip>
			</div>
			<p className="text-xs text-light-4">
				These profiles share the same username on different platforms.{' '}
				<Link href="/connected-channels" className="text-teal underline">
					Connect your accounts
				</Link>
				{' '}to merge them into one profile.
			</p>
			<div className="flex flex-col sm:flex-row gap-2">
				{profiles.map(profile => (<RelatedProfileCard key={`${profile.platform}-${profile.platformId}`} profile={profile}/>))}
			</div>
		</div>);
};
